import { render, staticRenderFns } from "./linked-opportunity-collapsible.vue?vue&type=template&id=28f764bc"
import script from "./linked-opportunity-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./linked-opportunity-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-opportunity-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f764bc')) {
      api.createRecord('28f764bc', component.options)
    } else {
      api.reload('28f764bc', component.options)
    }
    module.hot.accept("./linked-opportunity-collapsible.vue?vue&type=template&id=28f764bc", function () {
      api.rerender('28f764bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/linked-external-ids-collapsible/linked-opportunity-collapsible/linked-opportunity-collapsible.vue"
export default component.exports